export default __webpack_public_path__ + "static/media/recruiter2.1f0a12af.png";